// export const URL_API = "http://localhost:7000/api/v1";
// export const URL_IMAGES = "http://localhost:7000/images";
// export const URL = "http://localhost:7000";
// export const URL_API = "https://backend-hris.vercel.app/api/v1";
// export const URL_IMAGES = "https://backend-hris.vercel.app/images";
//
export const URL_API = "https://apinode.avapps.id/api/v1";
export const URL_IMAGES = "https://storage.avgroup.my.id/avhris/uploads";
// export const URL_IMAGES = "https://apinode.avapps.id/images";
export const URL = "https://apinode.avapps.id";
export const SECRET_KEY = "mysecret";
